module.exports = __webpack_public_path__ + "static/media/19ESCAP21.07f7e678.jpg";